"use strict";
//Spanish
const messages = {
  'ALERT-MIC': 'Missing Microphone',
  'ALERT-SPEAKER': 'Missing Speaker',
  'AUDIOCONTROLS-INPUT-HEADING': 'Entrada',
  'AUDIOCONTROLS-OUTPUT-HEADING': 'Salida',
  'AUDIOCONTROLS-CANCEL-BTN-LABEL': 'Cancelar',
  'AUDIOCONTROLS-SAVE-BTN-LABEL': 'Guardar',
  'BACK-BTN-LABEL': 'Espalda',
  'CALLCONTROLS-MUTE-BTN-LABEL' : 'Silencio',
  'CALLCONTROLS-HOLD-BTN-LABEL' : 'Poner en espera',
  'CALLCONTROLS-AUDIO-BTN-LABEL' : 'Audio',
  'CALLCONTROLS-KEYPAD-BTN-LABEL' : 'Teclado',
  'CALLCONTROLS-TRANSFER-BTN-LABEL' : 'Transferir',
  'CALLCONTROLS-NEWCALL-BTN-LABEL' : 'Nueva llamada',
  'CALLCONTROLS-HANGUP-BTN-LABEL' : 'Colgar',
  'CALLLIST-NOCALL' : 'Ninguna llamada activa',
  'CANCEL-BTN-LABEL' : 'Cancelar',
  'EMAIL-PLACEHOLDER' : 'Cõrreo electronico',
  'INCOMINGCALL-HEADER' : 'Llamada Entrante',
  'INCOMINGCALL-ACCEPT' : 'Aceptar',
  'INCOMINGCALL-DECLINE' : 'Ignorar',
  'INCOMINGCALL-VOICEMAIL' : 'Enviar al correo de voz',
  'LOGIN-INPUT-EMAIL-PLACEHOLDER' :'correo electrÃ³nico',
  'LOGIN-INPUT-PASSWORD-PLACEHOLDER' : 'contrasena',
  'LOGIN-CHECKBOX-LABEL' : 'RecuÃ©rdame',
  'LOGIN-FORGOTPASSWORD-LINK' : 'Olvidaste tu contraseÃ±a?',
  'LOGIN-SIGNIN-BTN-LABEL' : 'Registrarse',
  'LOGIN-FORGOTPW-INFO-TEXT' : 'Ingrese su correo electrÃ³nico para restablecer su contraseÃ±a.',
  'LOGIN-INPUT-PASSWORD-ERROR' : 'Por favor, introduzca la contraseÃ±a completa',
  'LOGIN-INPUT-EMAIL-ERROR' : 'Por favor introduzca un correo electrÃ³nico vÃ¡lido',
  'LOGIN-RESETPW-INPUT-PASSWORD-ERROR': 'Las contraseÃ±as deben coincidir',
  'LOGIN-FORGOTPW-RESETPASSWORD-BTN-LABEL' : 'Reiniciar',
  'LOGIN-RESETPW-INFO-TEXT' : ', Por favor, cambie su contraseÃ±a . La contraseÃ±a debe contener al menos una letra , sin espacios en blanco , no empezar con @ , y 8 o mÃ¡s caracteres ',
  'LOGIN-RESETPW-INPUT-PASSWORD-PLACEHOLDER' : 'Contrase~na',
  'LOGIN-RESETPW-INPUT-REPEATPASSWORD-PLACEHOLDER' : 'repita la contraseÃ±a',
  'LOGIN-RESETPW-CHANGE-BTN-LABEL' : 'Cambiar',
  'LOGIN-RESETPW-NOTNOW-BTN-LABEL' : 'Cancelar',
  'SETTINGS-VIEWALERT-BTN-LABEL' : 'Ver notificaciones',
  'SETTINGS-VERSION' : 'versiÃ³n ',
  'SETTINGS-HELPDOC-BTN-LABEL' : 'Documento de ayuda',
  'SETTINGS-CHECKBOX-LABEL' : 'Habilitar',
  'SETTINGS-CHECKBOX-HEADER' : 'Â¿Siempre arriba?',
  'SETTINGS-CLOSEALERTS-BTN-LABEL' : 'Cerrar notificaciones',
  'SETTINGS-LOGOUT-BTN-LABEL' : 'Cerrar sesiÃ³n',
  'SETTINGS-SELECT-EXTENSION-HEADER': 'ExtensiÃ³n',
  'SETTINGS-SELECT-RINGTONE-HEADER': 'Tono de llamada',
  'SETTINGS-SELECT-INPUTDEVICE-HEADER': 'Ddispositivo de entrada',
  'SETTINGS-SELECT-OUTPUTDEVICE-HEADER': 'Dispositivo de salida',
  'SETTINGS-SELECT-INTERFACETHEME-HEADER': 'Cambiar tema de interface',
  'SETTINGS-SELECT-INTERFACELANGUAGE-HEADER': 'Idioma de interface',
  'CALLHISTORY-BACK-BTN-LABEL' : 'Regresar',
  'CALLHISTORY-CLEAR-HISTORY-BTN-LABEL' : 'Borrar registro de llamada',
  'CALLHISTORY-HEADER' : 'Registro de llamadas',
  'CALLHISTORY-NO-HISTORY-MSG' : 'Ningun registro',
  'ALERTLOG-SETTINGS-BTN-LABEL' : 'Ajustes',
  'ALERTLOG-CLEAR-ALERT-BTN-LABEL' : 'Vaciar',
  'ALERTLOG-HEADER' : 'Notificaciones',
  'ALERTLOG-NO-ALERT-MSG' : 'No hay notificaciones disponibles',
  'UTILITIES-STATUS-ONHOLD' : 'En espera',
  'UTILITIES-STATUS-MUTED' : 'Silencio',
  'UTILITIES-STATUS-ACTIVE' : 'Activo',
  'UTILITIES-STATUS-DIALING' : 'Marcando',
  'ALERTITEM-HEADING-LOGIN' : 'Iniciar sesiÃ³n',
  'ALERTITEM-BODY-INCORRECT-CREDENTIALS-MSG' : 'El nombre de usuario o la contraseÃ±a son incorrectos.',
  'ALERTITEM-HEADING-LOST-NETWORK-CONNECTION' : 'Se perdiÃ³ la conexiÃ³n de red. Comprobar el estado de conexiÃ³n.',
  'DIALINPUT-PLACEHOLDER-TEXT' : ' # para llamar',
  'CALLDETAILS-HOLD' : 'En espera',
  'CALLDETAILS-MUTED': 'En silencio',
  'CALLLIST-STATUS-ACTIVE': 'Activo',
  'CALLLIST-STATUS-DIALING': 'Llamando',
  'CALLHISTORY-STATUS-FAILED': 'Registro de llamada incompleta',
  'HEADING-STATUS-CONNECTED' : 'Conectado',
  'HEADING-STATUS-OFFLINE' : 'Desconectado',
  'BLIND-BTN-LABEL': 'Directo',
  'ATTENDED-BTN-LABEL': 'Asistido',
  'SOFTPHONE-DTMF-COMMANDS': "Ingresar nÃºmero",
  'ARIA-LOGIN-SIGNIN-BTN': "BotÃ³n de inicio de sesiÃ³n",
  'ARIA-LOGIN-FORGOTPASSWORD-BTN': "botÃ³n de contraseÃ±a olvidada",
  'ARIA-CANCEL-BTN': "botÃ³n Cancelar",
  'ARIA-LOGIN-FORGOTPW-RESETPASSWORD-BTN': "botÃ³n de restablecimiento de contraseÃ±a",
  'ARIA-LOGIN-RESETPW-NOTNOW-BTN-LABEL': "botÃ³n de no ahora",
  'ARIA-CALLHISTORY-BACK-BTN-LABEL': 'BotÃ³n de volver atras',
  'ARIA-CALLHISTORY-CLEAR-HISTORY-BTN-LABEL': 'botÃ³n Borrar registro de llamadas',
  'ARIA-SETTINGS-LOGOUT-BTN': "botÃ³n de cierre de sesiÃ³n",
  'ARIA-SETTINGS-VIEWALERT-BTN': "botÃ³n ver notificaciones",
  'ARIA-SETTINGS-HELPDOC-BTN': "BotÃ³n de la ayuda de ayuda",
  'ARIA-RESETPW-CHANGE-BTN-LABEL': "botÃ³n de cambio de contraseÃ±a",
  'ARIA-BACKSPACE-BTN': 'botÃ³n de volver atras',
  'ARIA-DIALING-INPUT-FIELD': 'Cuadro de diÃlogo',
  'ARIA-HEADER': 'Encabezado',
  'ARIA-CLEAR-ALERTS-BUTTON': 'botÃ³n Borrar notificaciones',
  'ARIA-ALERT-LIST': 'lista de notificaciones',
  'ARIA-CHECKBOX': 'Casilla',
  'ARIA-SAVE-BTN': 'botÃ³n de Guardar',
  'ARIA-INPUT-FIELD': 'Cuadro de diÃlogo',
  'ARIA-INPUT': 'Entrada',
  'ARIA-KEYPAD': 'Teclado',
  'ARIA-KEY': 'Clave',
  'ARIA-AUDIO-SLIDER': 'Deslizador de audio',
  'ARIA-AUDIO-SLIDER-CONTROL': 'Deslizador de control de audio',
  'ARIA-MENU-ITEM': 'OpciÃ³n del menÃº',
  'ARIA-DROP-DOWN-MENU': 'Lista de MenÃº',
  'ARIA-BADGE-BUTTON': 'botÃ³n de la insignia',
  'ARIA-CALL-DETAIL': 'Detalles de llamadas',
  'ARIA-OPEN-SETTINGS-BUTTON': 'BotÃ³n de configuraciones abiertas',
  'UPDATE-HEADER': 'ActualizaciÃ³n disponible',
  'UPDATE-MSG': 'Â¿Le gustarÃ­a reiniciar la aplicaciÃ³n ahora?',
  'UPDATE-POSTPONE-BUTTON': 'Posponer (1 min)',
  'UPDATE-UPDATE-BUTTON': 'Actualizar',
  'ARIA-UPDATE-POSTPONE-BUTTON': 'botÃ³n de posponer',
  'ARIA-UPDATE-UPDATE-BUTTON': 'BotÃ³n de actualizaciÃ³n',
  'LOGIN-INPUT-SHOW': 'Mostrar',
  'LOGIN-INPUT-HIDE': 'Esconder',
  'ACTIVECALL-STATUS-RINGING': 'Sonando',
  'ACTIVECALL-STATUS-ACTIVE': 'Activo',
  'ACTIVECALL-STATUS-DIALING': 'Marcando',
  'ACTIVECALL-STATUS-FAILED': 'Llamada incompleta',
  'CALLHISTORY-TODAY': 'Registro de llamadas de hoy',
  'CALLHISTORY-YESTERDAY': 'Registro de llamadas de ayer',
  'ALERT_FORGOT_PASSWORD': 'Se te olvidÃ³ tu contraseÃ±a',
  'ALERT_SETTINGS_WILL_APPLY': 'Llamadas activas; los cambios seran aplicados cuando estẼ inactivo.',
  'ALERT_DIALING_OPTIONS': 'Opciones de marcaciÃ³n',
  'ALERT_DIALING_OPTIONS_BODY': 'Faltan las opciones de marcaciÃ³n',
  'ALERT_LOGIN': 'Iniciar sesiÃ³n',
  'ALERT_SOFTPHONE_EXTENSION': 'ExtensiÃ³n no estÃ disponible',
  'ALERT_MORE_INFORMATION': 'Para mÃ¡s informaciÃ³n visite:',
  'ALERT_LOST_CONNECTION': 'Se perdiÃ³ la conexiÃ³n de la red. Compruebe su conexiÃ³n.',
  'ARIA-PLAY-BTN': 'Botón de play',
  'ARIA-STOP-BTN': 'Botón Detener',
  'CONTACTS-STATUS-ONLINE': 'En línea',
  'CONTACTS-STATUS-OFFLINE': 'Desconectado',
  'CONTACTS-STATUS-BUSY': 'Ocupado',
  'CONTACTS-STATUS-UNKNOWN': 'Desconocido',
  'LABELLEDINPUT-LABEL-EMAIL': "Dirección de correo electrónico",
  'LABELLEDINPUT-LABEL-PASSWORD': "Password",
  'LABELLEDINPUT-LABEL-TEXT': "Texto",
  'LABELLEDINPUT-HINT-EMAIL': "Ingrese una dirección de correo electrónico válida a continuación.",
  'LABELLEDINPUT-HINT-PASSWORD': "Introduzca una contraseña válida a continuación.",
  'LABELLEDINPUT-HINT-TEXT': "Ingrese el texto a continuación.",
  'ARIA-ICON-AREA': 'Área de Iconos',
  'SETTINGS-ADVANCED-LOGGING': "Registro Avanzado",
  'APPMENU-SETTINGS-BTN-LABEL': "Configuración abierta",
  'APPMENU-HELP-BTN-LABEL': "Documentación de ayuda",
  'APPMENU-LOGOUT-BTN-LABEL': "Cerrar sesión",
  'APPMENU-VERSION': "versión ",
  'HEADER-SETTINGS-TITLE': "Ajustes",
  'SETTINGS-NOTIFICATIONS-BTN-LABEL': "Notificaciones",
  'SETTINGS-APPEARANCE-BTN-LABEL': "Apariencia",
  'SETTINGS-CONTACTS-BTN-LABEL': "Contactos",
  'SETTINGS-TROUBLESHOOTING-BTN-LABEL': "Solución de problemas",
  'SETTINGS-NOTIFICATIONS-BTN-DESCRIPTION': "Ajuste cómo recibe las actualizaciones.",
  'SETTINGS-APPEARANCE-BTN-DESCRIPTION': "Cambiar la apariencia de la aplicación.",
  'SETTINGS-CONTACTS-BTN-DESCRIPTION': "Importe sus contactos.",
  'SETTINGS-TROUBLESHOOTING-BTN-DESCRIPTION': "Herramientas para ayudarte a encontrar lo que está mal",
  'ARIA-BACK-BTN-LABEL': "Espalda",
  'HEADER-BACK-ARIA-LABEL' : 'espalda',
  'ENTITYLIST-SEARCH-FOUND': "encontró.",
  'ENTITYLIST-SEARCH-ITEM-PLURAL': "artículos",
  'ARIA-EVENT-LIST-ADD-NEW-GROUP': 'Nuevo grupo',
  'ENTITYLIST-NO-CONTACTS-FOUND': 'No se encontraron contactos',
  'ENTITYLIST-TRY-IMPORTING': 'Intente importar o agregar un contacto.',
  'ZEROSTATE-IMPORT-BTN-LABEL': 'Importar',
  'ENTITYLIST-NO-CONTACTS-DESCRIPTION': 'Ingrese el número para enviar o importar su lista de contactos en la configuración.',
  'ENTITYLIST-SEARCHBAR-SEARCH-CONTACTS': "Buscar contactos",
  'CONTACT-DETAILS-CARD-ZERO-STATE-BUTTON-LABEL' : 'Añadir un número',
  'CONTACT-DETAILS-CARD-ZERO-STATE-TITLE': 'No Información de Contacto',
  'CONTACT-DETAILS-CARD-ZERO-STATE-DESCRIPTION': 'Añadir un número para empezar',
  'ARIA-CARD-DETAILS-EDIT': 'Editar',
  'ARIA-CARD-DETAILS-DELETE': 'Borrar',
  'SETTINGS-DEVICES-BTN-LABEL': "Dispositivos",
  'SETTINGS-DEVICES-BTN-DESCRIPTION': "Cambiar cómo se configuran tus dispositivos.",
  'HEADER-CONTACTS-ARIA-LABEL' : "contactos",
  "SETTINGS-CATEGORY-HEADER-TROUBLESHOOTING": "Solución de problemas",
  "SETTINGS-TROUBLESHOOTING-CHECKBOX-LABEL": "Habilitar registro avanzado",
  "SETTINGS-TROUBLESHOOTING-DESCRIPTION" : "Cuando está habilitada, la aplicación creará registros avanzados para ayudar a diagnosticar los errores de la aplicación.",
  "SETTINGS-ADVANCED-LOGGING-TITLE" : 'Registro avanzado',
  'SETTINGS-CATEGORY-HEADER-ALERTS': "Alertas",
  "SETTINGS-VIEW-ALERTS-TITLE" : "Ver alertas",
  "SETTINGS-VIEW-ALERTS-DESCRIPTION": "Acceda a un registro de alertas y registros.",
  "SETTINGS-NOTIFICATIONS-TITLE": "Tono de llamada",
  "SETTINGS-NOTIFICATIONS-DESCRIPTION": "Cambiar el tono de llamada para las llamadas de voz entrantes..",
  'APPMENU-DEFAULT-THEME-BTN-LABEL': "Defecto",
  'APPMENU-LIGHT-THEME-BTN-LABEL': "Ligero",
  'APPMENU-DARK-THEME-BTN-LABEL': "Oscuro",
  'SETTINGS-APPEARANCE-TITLE-ALWAYS-ON-TOP': "Siempre en la cima",
  'SETTINGS-ALWAYS-ON-TOP-DESCRIPTION': "Cuando está activada, la aplicación siempre se mostrará por encima de sus otras aplicaciones.",
  'SETTINGS-APPEARANCE-CHECKBOX-LABEL': "Siempre en la cima?",
  'SETTINGS-APPEARANCE-TITLE-THEME': "Temas",
  'SETTINGS-THEMES-DESCRIPTION': "Los temas cambian la apariencia general de la aplicación.",
  'SETTINGS-APPEARANCE-TITLE-LANGUAGE': "Idioma",
  'SETTINGS-LANGUAGE-DESCRIPTION': "Cambiar el idioma lo cambia a lo largo de la aplicación.",
  'SETTINGS-CATEGORY-HEADER-DEVICE': "Dispositivo",
  "SETTINGS-CATEGORY-HEADER-CONTACTS" : "Contactos",
  'SETTINGS-CATEGORY-HEADER-APPEARANCE': "Apariencia",
  'SETTINGS-CATEGORY-HEADER-NOTIFICATIONS': "Notificaciones",
  'SETTINGS-INPUT-DEVICE-TITLE': "Dispositivo de entrada",
  'SETTINGS-INPUT-DEVICE-DESCRIPTION': "Establezca el dispositivo de audio que desea usar para la entrada.",
  'SETTINGS-OUTPUT-DEVICE-TITLE': "Dispositivo de salida",
  'SETTINGS-OUTPUT-DEVICE-DESCRIPTION': "Establezca el dispositivo de audio que desea usar para la salida.",
  'SETTINGS-CONTACTS-IMPORT-YOUR-CONTACTS': "Importe sus contactos",
  'SETTINGS-CONTACTS-IMPORT-CONTACTS-DESCRIPTION': "Seleccione su opción para importar contactos.",
  'SETTINGS-CONTACTS-SAMPLE-CSV': "Muestra CSV",
  'SETTINGS-CONTACTS-DOWNLOAD-SAMPLE-CSV-DESCRIPTION': "Al pulsar el botón de abajo se descargará un archivo CSV de ejemplo.",
  'SETTINGS-CONTACTS-BACKUP': 'Apoyo',
  'SETTINGS-CONTACTS-DOWNLOAD-BACKUP-CSV-DESCRIPTION': "Al pulsar el botón de abajo descargará una copia de seguridad CSV de sus contactos. Esto se recomienda antes de las importaciones.",
  'SETTINGS-CONTACTS-DOWNLOAD-SAMPLE-CSV-BUTTON': 'Descargar Muestra',
  'SETTINGS-IMPORT-LAST-SYNC-LABEL': "Importado",
  'SETTINGS-IMPORT-CONTACTS-SOURCES-BUTTON': "Importar",
  'SETTINGS-CONTACTS-DOWNLOAD-BACKUP-CSV-BUTTON': 'Descargar copia de seguridad',
  'ZEROSTATE-ADD-CONTACT-BTN-LABEL': 'Agregar contacto',
  'CONTACT-DETAILS-CARD-MODAL-CANCEL-BUTTON': "Cancelar",
  'CONTACT-DETAILS-CARD-MODAL-DELETE-BUTTON': "Borrar",
  'CONTACT-DETAILS-CARD-MODAL-HEADER-DELETE-CONTACT' : "¿Seguro que quieres eliminar este contacto??",
  'CONTACT-DETAILS-CARD-MODAL-DESCRIPTION-DELETE-CONTACT': "Al completar esta acción se eliminará permanentemente la información del contacto actual. ",
  'CONTACT-DETAILS-FORM-ERROR': 'Un campo en el formulario de abajo tiene un error.',
  'CONTACT-DETAILS-FORM-PERSONAL-INFO-HEADER': 'Informacion personal',
  'CONTACT-DETAILS-FORM-FIRST-NAME-HEADER': 'Nombre de pila',
  'CONTACT-DETAILS-FORM-FIRST-NAME-PLACEHOLDER': 'Introducir nombre',
  'CONTACT-DETAILS-FORM-LAST-NAME-HEADER': 'Apellido',
  'CONTACT-DETAILS-FORM-LAST-NAME-PLACEHOLDER': 'Introduzca el apellido',
  'CONTACT-DETAILS-FORM-COMPANY-NAME-HEADER': 'Empresa',
  'CONTACT-DETAILS-FORM-COMPANY-NAME-PLACEHOLDER': 'Introduzca el nombre de la empresa',
  'CONTACT-DETAILS-FORM-PHONE-NUMBERS-HEADER': 'Números de teléfono',
  'CONTACT-DETAILS-FORM-PHONE-BTN-LABEL': 'Añadir Teléfono',
  'CONTACT-DETAILS-FORM-CANCEL-BTN-LABEL': 'Cancelar',
  'CONTACT-DETAILS-FORM-SAVE-BTN-LABEL': 'Salvar',
  'CONTACT-DETAILS-FORM-NEW-CONTACT-HEADER': 'Nuevo contacto',
  'CONTACT-DETAILS-FORM-EDIT-CONTACT-HEADER': 'Editar contacto',
  'CONTACT-DETAILS-FORM-INPUT-ERROR': 'Este campo no puede dejarse en blanco.',
  'CONTACT-DETAILS-FORM-NUMBER-HEADER':'Número',
  'CONTACT-DETAILS-FORM-NUMBER-ERROR':'Introduzca un número de 10 dígitos válido',
  'CONTACT-DETAILS-FORM-NUMBER-PLACEHOLDER':'Ingresar número...',
  'CONTACT-DETAILS-FORM-PREFERRED-LABEL':'¿Privilegiado?',
  'CONTACT-DETAILS-FORM-SELECT-HOME': 'Casa',
  'CONTACT-DETAILS-FORM-SELECT-BUSINESS': 'Negocio',
  'CONTACT-DETAILS-FORM-SELECT-MOBILE': 'Móvil',
  'CONTACT-DETAILS-FORM-SELECT-OTHER': 'Otro',
  'CONTACT-DETAILS-FORM-SELECT-LABEL': 'Etiqueta',
  'NUMBER-SELECTION-MODAL-SELECT-NUMBER-TO-CALL': 'Seleccione el número para llamar',
  'NUMBER-SELECTION-MODAL-PREFERRED': 'Privilegiado',
  'CONTACT-DETAILS-FORM-NUMBER-ERROR-PROP':'Introduzca un número de válido'

};
module.exports = messages;



// WEBPACK FOOTER //
// ./src/locales/locale-es.js